import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Forward: 'Forward',
  ResetFilters: 'Reset filters',
  CopyLinkToInteraction: 'Copy link to interaction',
  Share: 'Share',
  PhoneCall: 'Phone call',
  ValueCopiedToClipboard: 'Value copied to clipboard',
  Note: 'Note',
  Email: 'Email',
  Edit: 'Edit',
  Delete: 'Delete',
  Save: 'Save',
  Cancel: 'Cancel',
  Date: 'Date',
  Title: 'Title',
  Description: 'Description',
  DeleteInteractionConfirmationMsg: 'Are you sure you want to delete this communication?',
  Search: 'Search',
  ExportToPdf: 'Export to PDF',
  ThisMonth: 'This month',
  LastSixMonths: 'Last 6 months',
  All: 'all',
  Appointment: 'Meeting report',
  NoInteractionsFound: 'No interactions were found for the selected filters.',
  NewPhoneCall: 'New phone call',
  NewNote: 'New note',
  NewAppointment: 'New meeting report',
  Contacts: 'Contacts',
  Attachments: 'Attachments',
  MsgUploadAttachmentFailed: 'An error occurred while uploading the attachment',

  PhoneNumber: 'Phone number',
  EnterpriseNumber: 'Enterprise number',
  VatNumber: 'VAT number',
  Status: 'Status',
  Type: 'Type',
  Sector: 'Sector',
  NoContactsPresentForRelation: 'No contacts present for this relation.',
  DateMandatory: 'Date is mandatory',
  TitleOrDescriptionMandatory: 'Please enter a title or description',
  DummyInteractionTitle: 'AdminPulse interactions',
  DummyInteractionDescription:
    'Dear,\n\nIn this screen you can create notes, register phone calls or write a report of a meeting you have had with this client.\n\nAs soon as you register a new interaction, this example will be removed.\n\nKind regards,\nAdminPulse team',
  CreateTimeRegistration: 'Create time registration',
  Pin: 'Pin',
  RemovePin: 'Remove pin',
  Pinned: 'Pinned',
  InteractionPinned: 'Interaction pinned',
  InteractionUnpinned: 'Interaction unpinned',
  GoToRelation: 'Go to relation',
  From: 'From',
  Subject: 'Subject',
  OpenEmail: 'Open email',
  LastModifiedBy: 'Last modified by {name}',
  CreatedBy: 'Created by',
  ShowInteractionsOfLinkedRelations: 'Show interactions of linked relations',
  AttachmentDeleted: 'Attachment deleted',
  SendEmail: 'SendEmail',
  EmailSent: 'Email sent',
  ToRecipient: 'To',
  Cc: 'CC',
  Bcc: 'Bcc',
  Reason: 'Reason',
  CreateNewToDo: 'Create new to-do',
  GenerateToDo: 'Generate to-dos',
  DateFrom: 'Date from',
  DateUntil: 'Date until',
  Tags: 'Tags',
  Reply: 'Reply',
  ReplyAll: 'Reply all',
  ExportToPdfStarted: 'Export started, this can take a few minutes.',
  SendInPdfViaEmail: 'Send in PDF via email',
  SomethingWentWrongWhileConvertingTheInteractionToPdf:
    'Something went wrong while converting the interaction to pdf',
  SomethingWentWrongWhileGeneratingToDos: 'Something went wrong while trying to generate to-dos',
  ExportSearchResultsToPdf: 'Export search results to PDF',
  Registered: 'Registered',
  Template: 'Template',
  Templates: 'Templates',
  NoTemplatesFound: 'No templates found',
  ChooseTemplate: 'Choose template',
  OpenInteractionTemplates: 'Open interaction templates',
  templateNotFound: 'The e-mail template could not be found',
  interactiontemplateNotFound: 'The interaction template could not be found',
  msgTemplateNotInLanguage: 'Template not available in language of relation.',
  msgInteractionTemplateNotInLanguage: 'Template not available in your language.',
  ToDos: "To-do's",
  OpenDetails: 'Open details',
  Deadline: 'Deadline',
  ChangeTodoStatus: 'Change todo status',
  AssignedTo: 'Assigned to',
  ChooseDocumentInAdminPulse: 'Choose document in AdminPulse',
  InteractionOverview: 'Interactions',
  Interactions: 'Interactions',
  ExportToExcel: 'Export to Excel',
  Relation: 'Relation',
  GotoInteraction: 'Go to interaction',
  // AI ToDo Suggestions
  GeneratedToDoSuggestions: 'AI Generated To-Do Suggestions',
  GeneratingToDoSuggestions: 'Generating AI To-Do suggestions...',
  ConfirmGenerateToDos: 'Generate AI To-Do Suggestions',
  ConfirmGenerateToDoMessage:
    'This will use AI to analyze the meeting notes and generate task suggestions. This action will consume credits from your account. Do you want to continue?',
  AcceptSuggestion: 'Accept',
  RejectSuggestion: 'Reject',
  AcceptAll: 'Accept All',
  RejectAll: 'Reject All',
  ProcessingSuggestions: 'Processing suggestions...',
  NoSuggestionsGenerated: 'No suggestions were generated.',
  SuggestionsProcessed: '{accepted} suggestion(s) accepted, {rejected} rejected.',
  RelationRequiredForTodo: 'Relation information is required to create to-dos.',
  Task: 'Task',
  Actions: 'Actions',
  AssignedTo: 'Assigned to',
  Deadline: 'Deadline',
  Remark: 'Remark',
  Unassigned: 'Unassigned',
  OpenTimeline: 'Open timeline',
  OpenInteraction: 'Open interaction',
  ExportToExcelStarted: 'Export to Excel started',
  // AI Summarization
  SummarizeWithAI: 'Summarize with AI',
  GeneratingSummary: 'Generating AI summary...',
  ConfirmGenerateSummary: 'Generate AI Summary',
  ConfirmGenerateSummaryMessage:
    'This will use AI to analyze the interaction content and generate a summary. This action will consume credits from your account. Do you want to continue?',
  SummaryGenerated: 'AI summary has been generated successfully.',
  SummarySaved: 'Summary has been saved successfully.',
  SomethingWentWrongWhileGeneratingSummary: 'Something went wrong while generating the summary',
  AISummary: 'AI Summary',
  AISummaryDescription: 'Review and edit the AI-generated summary below.',
  Summary: 'Summary',
  Loading: 'Loading...',
  SummaryWillAppearHere: 'Summary will appear here once generated',
  // AI Attachment Selection
  ConfirmGenerateToDoMessageWithAttachments:
    'This will use AI to analyze the meeting notes and selected attachments to generate task suggestions. This action will consume credits from your account. Do you want to continue?',
  ConfirmGenerateSummaryMessageWithAttachments:
    'This will use AI to analyze the interaction content and selected attachments to generate a summary. This action will consume credits from your account. Do you want to continue?',
  IncludeAllAttachments: 'Include all attachments',
  Yes: 'Yes',
});
export default messages;
